module.exports = __webpack_public_path__ + "static/checkout-626ca16c4f2041f52a5e3f4a0ef90a35.png";